import { createAction, props } from '@ngrx/store';

export const customerSignIn = createAction('[Public] Customer sign in', props<{ login: string; password: string }>());
export const resetPassword = createAction('[Public] Reset password', props<{ login: string }>());
export const simulateCustomer = createAction('[Public] Simulate customer', props<{ token: string }>());
export const verify2faCode = createAction('[Public] Verify 2 fa code', props<{ authToken: string; code: string }>());
